import React, { useEffect } from "react";
import { Link } from "react-router-dom";
  import { useNavigate } from "react-router-dom";
import "./Insights.css";



const Insights = () => {

// open page on top //
 useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // open page on top // 

  const navigate = useNavigate();
  const handleSeeMore = () => {
    navigate("/", {
      state: { scrollToContact: true },
    });
  };

  return (
    <>
     <div className="Insights">
      <div className="Insights-card">
       <h1 className="Insights-title">Insights & Blogs</h1>
      <p className="Insights-pera">
        Our advice is built on real experience within the care sector, including operating seven care homes across the South of England, with <br/>
         continued growth planned across the UK. We understand that delivering high-quality care alongside strong operational performance <br/>
          creates stable, sustainable services, and with the right guidance, managing a successful care business becomes far more achievable.</p>

      <div className="Insights-page">
                <div className="Insights-card">
                        <section className="Insights-section">
                            <div className="Insights-image">
                                <img src="https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/registration-changes-2026-standard.png" alt="" />
                            </div>
                            <div className="Insights-box">
                                <h2>How the CQC Registration process has changed in 2026</h2>
                                <p> The Care Quality Commission registration process has seen steady changes over the last 12 months,
                                     with a stronger focus on application quality, supporting evidence, and provider readiness. New 
                                     measures introduced by the CQC mean more applications are being rejected at the initial stage, 
                                     requiring providers to resubmit and rejoin the queue. Stricter validation checks, and updated 
                                     frameworks have been designed to raise standards across the sector. In this guide, we explore the key
                                      changes introduced in 2026 and what care providers need to do to prepare for a successful registration
                                       process.</p>
                                <button className="Insights-btn" onClick={handleSeeMore}>Get a quote </button>
                            </div>
                        </section>
                        <section className="Insights-section reverse">
                            <div className="Insights-image">
                                <img src="https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/complete-guide-to-cqc-compliance-standard.png" alt="" />
                            </div>
                            <div className="Insights-box">
                                <h2>The Complete Guide to CQC Compliance for Care Providers</h2>
                                <p>Maintaining compliance with the Care Quality Commission is a vital part of running a successful care service. From meeting the Fundamental
                                     Standards to preparing for inspections and maintaining accurate policies and procedures, understanding what’s expected can feel challenging.
                                      This complete guide explores the key areas of CQC compliance, helping care providers improve service quality, stay inspection-ready, and
                                       build confidence in delivering safe, effective, and person-centred care.</p>
                                <button className="Insights-btn" onClick={handleSeeMore}>Get a quote </button>
                            </div>
                        </section>
                        <section className="Insights-section">
                            <div className="Insights-image">
                                <img src="https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/beginners-guide-to-cqc-reg-standard-270th6.png" alt="" />
                            </div>
                            <div className="Insights-box">
                                <h2>A Beginners Guide to CQC Registration</h2>
                                <p>Starting a care business can feel overwhelming, especially when it comes to navigating CQC registration requirements. Whether you're launching
                                     a domiciliary care agency, supported living service, or residential care home, understanding the registration process is essential for operating
                                      legally and confidently. In this beginner’s guide, we’ll break down the key steps involved in registering with the Care Quality Commission, explain 
                                      what documents and policies you’ll need, and share practical tips to help you avoid common mistakes along the way.</p>
                                    <button className="Insights-btn" onClick={handleSeeMore}>Get a quote </button>
                            </div>
                        </section>
                </div>
        </div>
     </div>
     </div>
    </> 
  );
};

export default Insights;